import React from 'react'
import { Container } from '~/design-system/primitives'
import { Call, HeadsetMic, OutgoingMail, Whatsapp } from '~/icons'

interface FooterContent {
  children: React.ReactNode
  className?: string
  href?: string
}

const FooterSubTitle = ({ children }: FooterContent) => {
  return <h6 className="text-base font-medium">{children}</h6>
}

const FooterLabel = ({ children }: FooterContent) => {
  return <span className="block text-base font-medium">{children}</span>
}

const FooterSection = ({ children, className }: FooterContent) => {
  return <section className={`h-fit flex flex-col gap-4 ${className}`}> {children}</section>
}

const FooterLink = ({ children, href }: FooterContent) => {
  return (
    <a
      className="w-fit text-primary-light text-base hover:text-primary-orange"
      href={href}
      rel="noreferrer"
      target="_blank"
    >
      {children}
    </a>
  )
}

const paymentOptions = [
  { slugName: 'mastercard', name: 'Mastercard' },
  { slugName: 'visa', name: 'Visa' },
  { slugName: 'elo', name: 'Elo' },
  { slugName: 'amex', name: 'Amex' },
  { slugName: 'picpay', name: 'PicPay' },
  { slugName: 'pix', name: 'Pix' },
]

export default function Footer() {
  return (
    <footer className="bg-primary-black flex justify-center  gap-6 py-8 lg:gap-8 text-white">
      <Container className="  w-full">
        <div className="w-fit">
          <a href="/">
            <img alt="Logo Swift" className="min-h-6" src="/icons/logo-footer.svg" />
          </a>
        </div>

        <div className="flex flex-col gap-y-8 lg:flex-row gap-x-6 pt-8">
          <FooterSection>
            <FooterSubTitle>Canal de vendas:</FooterSubTitle>
            <div className="flex gap-2">
              <Whatsapp className="fill-primary-orange text-xl leading-none" />
              <div>
                <FooterLabel>Compre pelo Televendas ou WhatsApp:</FooterLabel>
                <FooterLink href="tel:1140208588">(11) 4020-8588</FooterLink>
              </div>
            </div>
            <div className="flex gap-2">
              <HeadsetMic className="fill-primary-orange text-xl leading-none" />
              <div>
                <FooterLabel>Horario de atendimento:</FooterLabel>
                <p className="text-primary-light text-base">
                  Segunda a Sexta 7h-19h, Sábados 7h-18h, Feriados 7h-15h.
                </p>
              </div>
            </div>
          </FooterSection>

          <FooterSection>
            <FooterSubTitle>Swift resolve:</FooterSubTitle>
            <div className="flex gap-2">
              <Call className="fill-primary-orange text-xl leading-none" />
              <div>
                <FooterLabel>Resolva Pelo Telefone:</FooterLabel>
                <FooterLink href="tel:08004002892">0800 400 2892</FooterLink>
              </div>
            </div>
            <div className="flex gap-2">
              <HeadsetMic className="fill-primary-orange text-xl leading-none" />
              <div>
                <FooterLabel>Horário de Atendimento:</FooterLabel>
                <p>Seg-Sex 9h-18h | Sab e Feriados 9h-15h</p>
              </div>
            </div>
            <div className="flex gap-2">
              <OutgoingMail className="fill-primary-orange text-xl leading-none" />
              <div>
                <FooterLabel>Resolva por e-mail:</FooterLabel>
                <FooterLink href="https://formularioswift-n503d6a2d.dispatcher.br1.hana.ondemand.com/">
                  Clique aqui
                </FooterLink>
              </div>
            </div>
          </FooterSection>

          <FooterSection className="gap-y-8 ">
            <div className="flex flex-col gap-y-2">
              <FooterSubTitle>Para você:</FooterSubTitle>
              <div className="flex flex-col gap-y-2">
                <FooterLink href="https://www.swift.com.br/receitas">Receitas Swift</FooterLink>
                <FooterLink href="https://www.swift.com.br/churrasco">Churrasco Swift</FooterLink>
                <FooterLink href="https://www.swift.com.br/pescados">Peixaria Swift</FooterLink>
                <FooterLink href="https://swift.gupy.io/">Trabalhe Conosco</FooterLink>
                <FooterLink href="https://www.swift.com.br/Institucional/politica-privacidade">
                  Política de privacidade
                </FooterLink>
                <FooterLink href="https://www.swift.com.br/institucional/faq">Dúvidas frequentes</FooterLink>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <FooterSubTitle>Compra Online:</FooterSubTitle>
              <div className="flex flex-col gap-y-2">
                <FooterLink href="https://www.swift.com.br/account">Seus Pedidos</FooterLink>
                <FooterLink href="https://www.swift.com.br/institucional/faq">FAQ</FooterLink>
                <FooterLink href="https://www.swift.com.br/regulamentos">Regulamentos</FooterLink>
                <FooterLink href="https://www.swift.com.br/aplicativo-swift">App Swift</FooterLink>
                <FooterLink href="https://www.swift.com.br/encarte-digital">Encarte Digital</FooterLink>
              </div>
            </div>
          </FooterSection>

          <FooterSection>
            <div className="flex flex-col gap-y-2">
              <FooterSubTitle>+ Swift:</FooterSubTitle>
              <div className="flex flex-col gap-2">
                <FooterLink href="https://swift.gupy.io/">A nossa história</FooterLink>
                <FooterLink href="https://swift.gupy.io/">Encontre nossas lojas</FooterLink>
                <FooterLink href="https://swift.gupy.io/">Sustentabilidade</FooterLink>
              </div>
            </div>
          </FooterSection>

          <FooterSection>
            <FooterSubTitle>Site seguro:</FooterSubTitle>
            <div>
              <img alt="Certificado PCI VTEX" className="min-h-15" src="/icons/pci-menor.svg" />
            </div>
            <FooterSubTitle>Formas de Pagamento:</FooterSubTitle>
            <div className="flex flex-row gap-x-6 gap-y-2 flex-wrap">
              {paymentOptions.map((item) => (
                <img
                  alt={item.name}
                  className="h-7.5"
                  key={item.slugName}
                  src={`/icons/logo-${item.slugName}.svg`}
                />
              ))}
            </div>
          </FooterSection>
        </div>
      </Container>
    </footer>
  )
}
